import { PagesConfirmModule } from './modules/pages-confirm/pages-confirm.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';


export let routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('@app/modules/auth/auth.module').then(
        (module) => module.AuthModule
      ),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('@app/modules/registers/registers.module'        
      ).then((module) => module.RegistersModule),
  },
  {
    path: 'mainmenu',
    loadChildren: () =>
      import('@app/modules/main.module').then((module) => module.MainModule),
    canActivate: [AuthGuard],
  },
   {
    path: 'digitalmailbox',
    loadChildren: () =>
      import('@app/modules/digital-mailbox/digital-mailbox.module').then((module) => module.DigitalMailboxModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'oauth2/login',
    loadChildren: () =>
      import('@app/modules/authen-methods/authen-methods.module').then(
        (module) => module.AuthenMethodsModule
      ),
  },
  {
    path: 'session/login',
    loadChildren: () =>
          import('@app/modules/otps/otps.module').then(
            (module) => module.OtpsModule
          ),
  },
  {
    path: 'sign',
    loadChildren: () =>
      import('@app/modules/sign-result/sign-result.module').then(
        (module) => module.SignResultModule
      ),
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('@app/modules/payment-result/payment-result.module').then(
        (module) => module.PaymentResultModule
      ),
  },{
    path: 'pageconfirm',
    loadChildren: () =>
      import('@app/modules/pages-confirm/pages-confirm.module').then(
        (module) => module.PagesConfirmModule
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('@app/modules/dashboard/dashboard.module').then((module) => module.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'policy',
    loadChildren: () =>
      import('@app/modules/privacy-policy/privacy-policy.module').then((module) => module.PrivacyPolicyModule),    
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/auth/login',
  },
  {
    path: '**',
    redirectTo: '/auth/login',
  },
  
];

// @dynamic
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      // onSameUrlNavigation: "reload",
      //  enableTracing: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
